import React from 'react';

import { useActionItemContext } from '../../context';
import { CreatedOnProps } from '../../types';
import CreatedAt from './CreatedAt';

const CreatedOn = ({ className }: CreatedOnProps) => {
  const {
    actionItem: { createdAt },
  } = useActionItemContext();

  if (!createdAt) {
    return null;
  }

  return <CreatedAt className={className} createdAt={createdAt} />;
};

export default React.memo(CreatedOn);
